import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Editor } from '@tinymce/tinymce-react';
import './AddBlogForm.css';
import { useAdminContext } from '../../context/AdminContext';

const AddBlogForm = ({ onClose, onSuccess }) => {
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [author, setAuthor] = useState('');
  const [imageLink, setImageLink] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [seoTitle, setSeoTitle] = useState('');
  const [seoDescription, setSeoDescription] = useState('');
  const [seoKeywords, setSeoKeywords] = useState('');
  const [content, setContent] = useState('');

  const navigate = useNavigate();
  const { addBlog } = useAdminContext();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImageBase64(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const formatTitleForURL = (title) =>
    title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!imageBase64 && !imageLink) {
      toast.error('Please upload an image or provide an image URL');
      return;
    }

    const formattedTitle = formatTitleForURL(title);

    const blogData = {
      title,
      content,
      imageBase64,
      imageLink,
      createdAt: new Date(),
      formattedDate: date,
      author,
      urlSlug: formattedTitle,
      seoTitle,
      seoDescription,
      seoKeywords: seoKeywords.split(',').map(k => k.trim()).join(', ')
    };

    try {
      await addBlog(blogData);
      toast.success("Blog added successfully!");
      onClose();
      if (onSuccess) onSuccess();
    } catch (err) {
      toast.error("Error uploading blog: " + err.message);
    }
  };

  return (
    <div className="addblog">
      <div className="close" onClick={onClose}>X</div>
      <div className="addblog-form">
        <h2>Add a Blog</h2>
        <form onSubmit={handleSubmit} className="blog-form">
          <div className="form-group">
            <label htmlFor="title">Title</label>
            <input type="text" id="title" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>

          <div className="form-group">
            <label>Content</label>
            <Editor
              apiKey="xq724x2m6sc4ecxig8wtrji2ykjkc5xusce71tfozatsdcrd" // you can register for a free API key at TinyMCE
              value={content}
              onEditorChange={(newContent) => setContent(newContent)}
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                ],
                toolbar:
                  'undo redo | formatselect | fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | link image media | code',
              }}
            />
          </div>

          <div className="form-group">
            <label htmlFor="image">Upload Image</label>
            <input type="file" id="image" onChange={handleImageChange} accept="image/*" />
          </div>

          <div className="form-group">
            <label htmlFor="imageLink">Or Image URL</label>
            <input type="url" id="imageLink" value={imageLink} onChange={(e) => setImageLink(e.target.value)} />
          </div>

          <div className="form-group">
            <label htmlFor="date">Date</label>
            <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} required />
          </div>

          <div className="form-group">
            <label htmlFor="author">Author</label>
            <input type="text" id="author" value={author} onChange={(e) => setAuthor(e.target.value)} required />
          </div>

          <h3>SEO Settings</h3>
          <div className="form-group">
            <label>SEO Title</label>
            <input type="text" value={seoTitle} onChange={(e) => setSeoTitle(e.target.value)} />
          </div>

          <div className="form-group">
            <label>SEO Description</label>
            <input type="text" value={seoDescription} onChange={(e) => setSeoDescription(e.target.value)} />
          </div>

          <div className="form-group">
            <label>SEO Keywords</label>
            <input type="text" value={seoKeywords} onChange={(e) => setSeoKeywords(e.target.value)} />
          </div>

          {imageBase64 && <img src={imageBase64} alt="Preview" className="image-preview" />}

          <button type="submit" className="submit-btn">Add Blog</button>
        </form>
      </div>
    </div>
  );
};

export default AddBlogForm;
